"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTR_NAME = 'data-e7n';
exports.FN_NAME = 'tr';
